import React, { useMemo } from 'react';
// @ts-ignore
import styles from './DENTToothPeriodontal.module.scss';
import { ToothPlacement } from '../../Enums/ToothPlacement.enum';
import { ToothPeriodontal } from '../../../../graphql/graphql';

interface Props {
	periodontal?: ToothPeriodontal;
	side?: ToothPlacement;
}

const getDiseasesForSide = (
	periodontal: ToothPeriodontal,
	side?: ToothPlacement,
) => {
	switch (side) {
		case ToothPlacement.BUCCAL_LEFT:
			return [
				periodontal.distoBuccal,
				periodontal.buccal,
				periodontal.mesioBuccal,
			];
		case ToothPlacement.BUCCAL_RIGHT:
			return [
				periodontal.mesioBuccal,
				periodontal.buccal,
				periodontal.distoBuccal,
			];
		case ToothPlacement.LINGUAL_LEFT:
			return [
				periodontal.distoPalatal,
				periodontal.palatal,
				periodontal.mesioPalatal,
			];
		case ToothPlacement.LINGUAL_RIGHT:
			return [
				periodontal.mesioPalatal,
				periodontal.palatal,
				periodontal.distoPalatal,
			];
		case ToothPlacement.PALATAL_LEFT:
			return [
				periodontal.distoPalatal,
				periodontal.palatal,
				periodontal.mesioPalatal,
			];
		case ToothPlacement.PALATAL_RIGHT:
			return [
				periodontal.mesioPalatal,
				periodontal.palatal,
				periodontal.distoPalatal,
			];
		default:
			return [];
	}
};

const DENTToothPeriodontal = ({ periodontal, side }: Props) => {
	if (!(periodontal && side)) {
		return null;
	}

	const periodontalDiseases = useMemo(
		() => getDiseasesForSide(periodontal, side),
		[periodontal, side],
	);

	return (
		<div className={styles.wrapper}>
			{periodontalDiseases.map((periodontalSide, index) => (
				<div className={styles.column} key={`column-${index}`}>
					<span
						className={
							periodontalSide?.plaque ? styles.plaque : styles.empty
						}></span>
					<span
						className={
							periodontalSide?.bleeding ? styles.bleeding : styles.empty
						}></span>
					<span
						className={periodontalSide?.pus ? styles.pus : styles.empty}></span>
				</div>
			))}
		</div>
	);
};

export default DENTToothPeriodontal;
